// extracted by mini-css-extract-plugin
export default {"root":"iXdN8E","debugBorder":"lCmZf5"};